import React from "react";

const PieChartSkeleton = () => {
  return (
    <div className="w-full bg-white p-4 rounded-lg shadow h-64 animate-pulse">
      <div className="h-5 w-32 bg-gray-200 dark:bg-gray-600rounded mb-4"></div>

      <div className="relative w-full h-full flex items-center justify-center">
        <div className="w-36 h-36 bg-gray-200 dark:bg-gray-600 rounded-full"></div>

        <div className="absolute right-0 top-1/2 -translate-y-1/2 space-y-2">
          <div className="h-3 w-20 bg-gray-200 dark:bg-gray-600  rounded"></div>
          <div className="h-3 w-16 bg-gray-200 dark:bg-gray-600  rounded"></div>
        </div>
      </div>
    </div>
  );
};

export default PieChartSkeleton;
